import { render } from "./TaskFeedback.vue?vue&type=template&id=221d7b34"
import script from "./TaskFeedback.vue?vue&type=script&lang=js"
export * from "./TaskFeedback.vue?vue&type=script&lang=js"

import "./TaskFeedback.vue?vue&type=style&index=0&id=221d7b34&lang=css"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__